/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ImageSizeLarge({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1.4 2a.6.6 0 0 1 .6-.6h12a.6.6 0 1 1 0 1.2H2a.6.6 0 0 1-.6-.6M1.4 14a.6.6 0 0 1 .6-.6h12a.6.6 0 0 1 0 1.2H2a.6.6 0 0 1-.6-.6M2 9.4a.6.6 0 1 0 0 1.2h1a.6.6 0 1 0 0-1.2zM12.4 10a.6.6 0 0 1 .6-.6h1a.6.6 0 1 1 0 1.2h-1a.6.6 0 0 1-.6-.6M2 5.4a.6.6 0 0 0 0 1.2h1a.6.6 0 1 0 0-1.2zM12.4 6a.6.6 0 0 1 .6-.6h1a.6.6 0 1 1 0 1.2h-1a.6.6 0 0 1-.6-.6" /><path fill="currentColor" fillRule="evenodd" d="M6.75 4.9A2.1 2.1 0 0 0 4.65 7v2c0 1.16.94 2.1 2.1 2.1h2.5a2.1 2.1 0 0 0 2.1-2.1V7a2.1 2.1 0 0 0-2.1-2.1zM5.85 7a.9.9 0 0 1 .9-.9h2.5a.9.9 0 0 1 .9.9v2a.9.9 0 0 1-.9.9h-2.5a.9.9 0 0 1-.9-.9z" clipRule="evenodd" /></svg>;
}
;